@if (dataSource) {
  <icz-table
    id="cross-reference-table"
    tableTitle="Související"
    [columnsData]="columnsData"
    [expandedRow]="expandedRow"
    [dataSource]="dataSource"
    [rowSelectionDisabler]="rowSelectionDisabler"
    (selectedRowsChanged)="selectedRows = $event"
    (contextMenuRequested)="toolbar.openContextMenu($event)"
  >

    <icz-label notFoundLabel noDataLabel label="Žádné související objekty"></icz-label>
    <icz-cross-reference-toolbar-buttons
      tools #toolbar
      [selectedRows]="selectedRows"
      [esslEntity]="esslEntity"
      (operationCompleted)="onOperationCompleted()"
    ></icz-cross-reference-toolbar-buttons>

    <ng-template #iczExpandedRowTemplate let-row>
      @for (expandedObject of row.strongCrossReferenceObjects; track expandedObject.id) {
        <div class="reference-expanded-row">
          @for (column of columnsDisplayed; track column.id) {
            <div [style.width.px]="column.width" class="reference-expanded-col" [id]="'expandedCol' + column.id">
              @switch (column.id) {
                @case (CrossReferenceColumnId.OBJECT_CLASS) {
                  <icz-object-class-icon [objectClass]="$any(expandedObject.objectClass)"></icz-object-class-icon>
                }
                @case (CrossReferenceColumnId.SUBJECT) {
                  <span class="reference-cell-overflow mr-4" [iczTooltip]="expandedObject.subject">{{ expandedObject.subject }}</span>
                }
                @case (CrossReferenceColumnId.REF_NUMBER) {
                  <icz-ref-number-link
                    [entity]="getEntityLink(expandedObject)"
                  ></icz-ref-number-link>
                }
                @case (CrossReferenceColumnId.OWNER_FUNCTIONAL_POSITION_ID) {
                  @if (expandedObject.ownerFunctionalPositionId | findFunctionalPositionById | async; as owner) {
                    <span [iczTooltip]="owner">
                      {{ owner }}
                    </span>
                  }
                }
                @case (CrossReferenceColumnId.CREATED_AT) {
                  <span>{{expandedObject.createdAt | localizedDatetime}}</span>
                }
                @case (CrossReferenceColumnId.ROLE) {
                  @let role = thisEntityRoleInReference(expandedObject);
                  <span [iczTooltip]="role">{{ role }}</span>
                }
                @case (CrossReferenceColumnId.NAME) {
                  <span [iczTooltip]="expandedObject.name">{{ expandedObject.name }}</span>
                }
                @case (CrossReferenceColumnId.TYPE) {
                  <span>{{ expandedObject.type | findInList: crossReferenceTypeOptions | translate }}</span>
                }
              }
            </div>
          }
        </div>
      }
    </ng-template>

    <ng-container *iczColumnTemplate="let row from [dataSource, columnsData]; id: CrossReferenceColumnId.OBJECT_CLASS">
      <icz-object-class-icon [objectClass]="$any(row.objectClass)"></icz-object-class-icon>
    </ng-container>
    <ng-container *iczColumnTemplate="let row from [dataSource, columnsData]; id: CrossReferenceColumnId.REF_NUMBER">
      <div class="row">
        <icz-ref-number-link
          [entity]="getEntityLink(row)"
        ></icz-ref-number-link>
        @if (row.type === 'STRONG' && row.strongCrossReferenceObjects) {
          <icz-button
            (onAction)="toggleExpandedRow(row, $event)"
            [svgIcon]="expandedRow === row ? 'expand_more' : 'after'"
            [iczTooltip]="expandedRow === row ? 'Sbalit propojení' : 'Rozbalit propojení'"
            size="small"
            noBorder
            class="reference-expander"
            label="propojené spisy"
          ></icz-button>
        }
      </div>
    </ng-container>
    <ng-container *iczColumnTemplate="let row from [dataSource, columnsData]; id: CrossReferenceColumnId.OWNER_FUNCTIONAL_POSITION_ID; withEllipsis: true">
      @if (row.ownerFunctionalPositionId | findFunctionalPositionById | async; as owner) {
        <span [iczTooltip]="owner">{{ owner }}</span>
      }
    </ng-container>
    <ng-container *iczColumnTemplate="let row from [dataSource, columnsData]; id: CrossReferenceColumnId.CREATED_AT; withEllipsis: true">
      <span>{{row.createdAt | localizedDatetime}}</span>
    </ng-container>
    <ng-container *iczColumnTemplate="let row from [dataSource, columnsData]; id: CrossReferenceColumnId.ROLE; withEllipsis: true">
      <span>{{thisEntityRoleInReference(row)}}</span>
    </ng-container>

  </icz-table>
}
